import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { handleActions } from 'redux-actions';
import { queueSafetyChangeForDeviation, recordDeviationSafety, setPageSafety, logLastAdRefresh, setSafetyState } from './actions';
import { reduxKey } from './constants';
var _state_refreshCount;
const handler = handleActions({
    [setPageSafety.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            currentSafety: action.payload.safety
        }),
    [recordDeviationSafety.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            deviationSafety: _object_spread_props(_object_spread({}, state.deviationSafety), {
                [action.payload.deviationId]: action.payload.safety
            })
        }),
    [queueSafetyChangeForDeviation.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            queuedDeviationId: action.payload.deviationId
        }),
    [logLastAdRefresh.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            lastAdRefresh: action.payload.time,
            refreshCount: ((_state_refreshCount = state.refreshCount) !== null && _state_refreshCount !== void 0 ? _state_refreshCount : 0) + 1
        }),
    [setSafetyState.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            safetyState: action.payload.safeState
        })
}, {
    currentSafety: 'off',
    deviationSafety: {},
    lastAdRefresh: 0,
    refreshCount: 0,
    safetyState: 'ready'
});
const reducers = {
    [reduxKey]: handler
};
export default reducers;
